const Badge = ({ children, color = '#3B82F6', variant = 'filled' }) => (
  <span style={{
    display: 'inline-flex', alignItems: 'center', padding: '2px 10px',
    borderRadius: 12, fontSize: 11, fontWeight: 600, lineHeight: '18px',
    background: variant === 'filled' ? color + '18' : 'transparent',
    color: color,
    border: variant === 'outline' ? `1px solid ${color}40` : 'none',
  }}>
    {children}
  </span>
);

export default Badge;
